import { styled, Chip as MuiChip } from '@mui/material';

const Chip = styled(MuiChip)(({ theme }) => ({
    borderRadius: '16px',
    '&.MuiChip-colorPrimary': {
        backgroundColor: '#e6ebee',
    },
    marginTop: '0 !important',
    width: 'fit-content',
    color: 'black',
}));

export default Chip;